import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../web/components-v2/Theme/theme';
import { shadowSm } from '../../web/styles/shadows';

export const timeTrackingStyles = StyleSheet.create({
	card: {
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		boxShadow: shadowSm,
		boxSizing: 'border-box',
	},
	cardBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		padding: SPACE[20],
	},
	cardTitle: {
		color: THEME.colors.text.main,
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.semibold,
		margin: 0,
	},
	muted: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	number: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontVariantNumeric: 'tabular-nums',
	},
	page: {
		background: THEME.colors.background.main,
		boxSizing: 'border-box',
		color: THEME.colors.text.main,
		display: 'flex',
		flexDirection: 'column',
		fontFamily: THEME.typography.fontFamilies.lexend,
		gap: SPACE[20],
		minHeight: '100%',
		padding: SPACE[24],
	},
	pageTitle: {
		color: THEME.colors.text.main,
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: THEME.typography.fontSizes.xl,
		fontWeight: THEME.typography.fontWeights.semibold,
		margin: 0,
	},
	actionCell: {
		textAlign: 'right',
		whiteSpace: 'nowrap',
	},
	emptyCell: {
		color: THEME.colors.text.main,
		textAlign: 'center',
	},
	tableCard: {
		overflowX: 'auto',
	},
	truncate: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
});
